import type { KeyboardEvent } from 'react'

export function EscapeKeyPressed(e: KeyboardEvent): boolean {
  return e.type === 'keyup' && Boolean(e.keyCode) && e.keyCode === 27
}
